import { Button, Container, ExpandableContainer, Header, Text } from '@gasbuddy/react-components';
import { useWindowSize } from '@gasbuddy/react-hooks';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import StationsMapContext from '../../context/selected-station-map';
import AmenityPropType from '../../prop-types/amenity';
import ReviewPropType from '../../prop-types/review';
import AmenitiesList from '../AmenitiesList';
import ReviewItem from '../ReviewItem';
import styles from './VerboseStationInfo.module.css';

const cx = classnames.bind(styles);

export default function VerboseStationInfo({ amenities, reviews, stationId }) {
  const { t } = useTranslation(['station', 'amenity', 'review']);
  const selectedStationId = useContext(StationsMapContext);
  const { mobile } = useWindowSize();
  const expandedValue = !mobile && selectedStationId === stationId;

  // TODO: Set toggleText of ExpandableContainer once new version of react-components is published
  return (
    <ExpandableContainer expanded={expandedValue}>
      <Container fluid>
        <Header as="h3" className={cx('dataLabel')} color="midnight">
          {t('amenities', { ns: 'amenity' })}
        </Header>
        <AmenitiesList amenities={amenities} expanded={false} />
        <br />
        <Header as="h3" className={cx('dataLabel')} color="midnight">
          {t('reviews', { ns: 'review' })}
        </Header>
        {reviews?.length ? reviews.map(review => (
          <ReviewItem
            key={review.reviewId}
            review={review}
          />
        )) : (
          <Text as="p" color="midnight" italic>
            {t('noReviewsFound', { ns: 'review' })}
          </Text>
        )}
        <br />
        <Button
          as={Link}
          to={`/station/${stationId}`}
          primary
          fluid
        >
          {t('viewFullStationDetails', { ns: 'station' })}
        </Button>
        <br />
      </Container>
    </ExpandableContainer>
  );
}

VerboseStationInfo.propTypes = {
  amenities: PropTypes.arrayOf(AmenityPropType),
  reviews: PropTypes.arrayOf(ReviewPropType),
  stationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

VerboseStationInfo.defaultProps = {
  amenities: [],
  reviews: null,
};
